<div class="d-flex flex-column justify-content-center">
  <span class="text-1418 bold text-center" [innerHtml]="'g.view-photo.header'|ketranslate| safe:'html'">

  </span>
  <span class="text-1418 bold text-center">
    {{'g.view-photo.header2'|ketranslate}}
  </span>
  <div class="py-2 text-center">

    <!-- <a href="https://play.google.com/store/apps/details?id=kerry.express.th.mobile.tracking&amp;hl=th" class="px-1"
    target="_blank">
    <img src="assets/resource/google-play.png" width="60"> </a>

  <a href="https://itunes.apple.com/th/app/kerry-express/id909585896?l=th&amp;mt=8" target="_blank" class="icon ios"
    class="px-1">
    <img src="assets/resource/apple-store.png" width="60">
  </a> -->

    <button class="ke-btn-outline text-1216 ke-color-primary" mat-dialog-close type="button" (click)="openApp()">
      <span>
        <mat-icon class="align-bottom">phone_iphone</mat-icon>
        {{'g.view-photo.download-app'|ketranslate}}
      </span>
    </button>


  </div>
  <span class="text-1418 text-center pb-2">
    {{'g.view-photo.qr'|ketranslate}}
  </span>
  <div class="text-center">
    <div #qrcode></div>
  </div>

  <!-- <img class="d-inline-flex justify-content-center" src="{{'data:image/jpg;base64,' + data.shipment.sig}}" />
  <span class="text-1216 py-2 bold d-inline-flex justify-content-center">{{data.shipment.cnee}}</span> -->

  <span
    class="text-1216 light pb-2 ke-color-gray d-inline-flex justify-content-center">{{'g.date-delivery'|ketranslate}}
    {{data.shipment_status[0].s_date}}</span>
  <div class="d-inline-flex justify-content-center">
    <button class="ke-btn-primary ke-background-primary text-1216" style="padding: 3px 40px;color: white; "
      mat-dialog-close type="button"><span>{{'g.close'|translate}}</span></button>
  </div>
</div>
